import $ from 'jquery';

var Ember = Ember || {};

Ember.Preview = {
  init: function () {
    (this.$previewData = $('.js-feedback-preview')),
      (this.baseUrl = this.$previewData.attr('data-base-url')),
      (this.employeeId = this.$previewData.attr('data-employee-id')),
      (this.stars = this.$previewData.attr('data-stars')),
      (this.uuid = this.$previewData.attr('data-uuid')),
      (this.baseParams = {
        stars: this.stars,
        language: this.$previewData.attr('data-language'),
        preview: true,
      });
    return this;
  },
  fullPath: function () {
    var base = [this.baseUrl, this.channel, this.employeeId, this.uuid];
    if (this.social) {
      return base.concat([this.social]).join('/');
    } else {
      return base.join('/');
    }
  },
  url: function (social) {
    var queryParams = $.param(
      $.extend(false, this.baseParams, this.formParams()),
    ).replace(/%20/g, '+');
    this.social = social;
    return this.fullPath() + '?' + queryParams + '#stars';
  },
  setIFrameSrc: function (className, url) {
    var originalFrame = document.getElementsByClassName(className)[0];
    var newIFrame = document.createElement('iframe');
    var parentEle = originalFrame.parentNode;
    newIFrame.setAttribute('class', originalFrame.getAttribute('class'));
    newIFrame.src = url;

    parentEle.replaceChild(newIFrame, originalFrame);
  },
  reload: function (channel) {
    this.channel = channel;
    this.setIFrameSrc('js-iframe-preview', this.url());
    this.setIFrameSrc('js-iframe-social-preview', this.url('social'));
  },
  /**
   * formParams() returns an object with the current channels dynamic texts key values
   * these are sent as get params to the Ember app.
   * @return {Object} object
   */
  formParams: function () {
    var $inputs = $('#' + this.channel + ' .js-feedback-preview-input');
    var params = {};
    $inputs.each(function (_, $input) {
      var $inputParent = $($input.parentElement);
      params[$inputParent.find('.js-preview-key').attr('value')] = $input.value;
    });
    return params;
  },
};

$(document).ready(function () {
  var activeChannel, preview;

  if ($('.js-feedback-preview').length) {
    activeChannel = $('li.active a[data-toggle="tab"]')
      .attr('data-channel')
      .toLowerCase();

    preview = Ember.Preview.init();
    preview.reload(activeChannel);
    $('.js-preview-update, .js-preview-channel').click(function (e) {
      var channel =
        $(e.currentTarget).find('a').attr('data-channel') ||
        $('li.active a').attr('data-channel');
      e.preventDefault();
      preview.reload(channel.toLowerCase());
    });
  }
});
